<template>
  <div class="home">
    <div class="data-table" id="data-table">
      <div class="header">
        <div>Title</div>
        <div>Type</div>
        <div>Status</div>
        <div>Country</div>
        <div>From</div>
        <div>To</div>
        <div>Promos (created/limit)</div>
        <div>Claims per promo</div>
        <div>Discount amounts</div>
        <div>Discounts created (number/value)</div>
        <div>Discounts used (number/value)</div>
      </div>
      <div
        v-for="campaign in referralCampaigns"
        v-bind:key="campaign.id"
        class="row"
      >
        <div class="cell">
          {{ getReferralCampaignTitle(campaign) }}
        </div>
        <div class="cell">Referral</div>
        <div class="cell">
          {{ getReferralCampaignStatus(campaign) }}
        </div>
        <div class="cell">
          {{ campaign.country }}
        </div>
        <div class="cell">
          {{ formatDate(campaign.startsAt) }}
        </div>
        <div class="cell">
          {{ formatDate(campaign.endsAt) }}
        </div>
        <div class="cell">
          {{ campaign.createdCodesCount }}/{{ campaign.maxCodes }}
        </div>
        <div class="cell">
          {{ campaign.maxClaimsPerCode }}
        </div>
        <div class="cell">
          {{ campaign.currency }}
          {{ campaign.referringUserDiscountAmount / 100 }},
          {{ campaign.currency }}
          {{ campaign.referredUserDiscountAmount / 100 }}
        </div>
        <div class="cell">
          {{ campaign.createdDiscountsCount }} ({{ campaign.currency }}
          {{ campaign.createdDiscountsAmount / 100 }})
        </div>
        <div class="cell">
          {{ campaign.appliedDiscountsCount }} ({{ campaign.currency }}
          {{ campaign.appliedDiscountsAmount / 100 }})
        </div>
      </div>
      <div v-for="promo in influencerPromos" v-bind:key="promo.id" class="row">
        <div class="cell">
          {{ promo.shareableCode }}<br />
          <span style="font-size: 10px">{{promo.id}}</span>
        </div>
        <div class="cell">{{promo.type}}</div>
        <div class="cell">
          {{ getInfluencerPromoStatus(promo) }}
        </div>
        <div class="cell">-</div>
        <div class="cell">
          {{ formatDate(promo.createdAt) }}
        </div>
        <div class="cell">
          {{ formatDate(promo.expiresAt) }}
        </div>
        <div class="cell">-</div>
        <div class="cell">{{ promo.claimsCount }}/{{ promo.maxClaims }}</div>
        <div class="cell">
          {{ promo.currency }}
          {{ promo.influencerDiscountAmount / 100 }},
          {{ promo.currency }}
          {{ promo.discountAmount / 100 }}
        </div>
        <div class="cell">
          {{ getInfluencerPromoClaimedDiscountCount(promo) }}
          ({{ promo.currency }}
          {{ getInfluencerPromoClaimedDiscountAmount(promo) / 100 }})
        </div>
        <div class="cell">
          {{ promo.appliedDiscountsCount }} ({{ promo.currency }}
          {{ promo.appliedDiscountsAmount / 100 }})
        </div>
      </div>
    </div>
    <div class="data-table" id="data-table" style="margin-top: 30px">
      <div class="header">
        <div>Title</div>
        <div>Type</div>
        <div>Status</div>
        <div>Country</div>
        <div>From</div>
        <div>To</div>
        <div>Promos (created/limit)</div>
        <div>Claims per promo</div>
        <div>Discount amounts</div>
        <div>Discounts created (number/value)</div>
        <div>Discounts used (number/value)</div>
      </div>
      <div
        v-for="campaign in referralCampaignsOld"
        v-bind:key="campaign.id"
        class="row"
      >
        <div class="cell">
          {{ getReferralCampaignTitle(campaign) }}
        </div>
        <div class="cell">Referral</div>
        <div class="cell">
          {{ getReferralCampaignStatus(campaign) }}
        </div>
        <div class="cell">
          {{ campaign.country }}
        </div>
        <div class="cell">
          {{ formatDate(campaign.startsAt) }}
        </div>
        <div class="cell">
          {{ formatDate(campaign.endsAt) }}
        </div>
        <div class="cell">
          {{ campaign.createdCodesCount }}/{{ campaign.maxCodes }}
        </div>
        <div class="cell">
          {{ campaign.maxClaimsPerCode }}
        </div>
        <div class="cell">
          {{ campaign.currency }}
          {{ campaign.referringUserDiscountAmount / 100 }},
          {{ campaign.currency }}
          {{ campaign.referredUserDiscountAmount / 100 }}
        </div>
        <div class="cell">
          {{ campaign.createdDiscountsCount }} ({{ campaign.currency }}
          {{ campaign.createdDiscountsAmount / 100 }})
        </div>
        <div class="cell">
          {{ campaign.appliedDiscountsCount }} ({{ campaign.currency }}
          {{ campaign.appliedDiscountsAmount / 100 }})
        </div>
      </div>
      <div v-for="promo in influencerPromosOld" v-bind:key="promo.id" class="row">
        <div class="cell">
          {{ promo.shareableCode }}<br />
          <span style="font-size: 10px">{{promo.id}}</span>
        </div>
        <div class="cell">{{promo.type}}</div>
        <div class="cell">
          {{ getInfluencerPromoStatus(promo) }}
        </div>
        <div class="cell">-</div>
        <div class="cell">
          {{ formatDate(promo.createdAt) }}
        </div>
        <div class="cell">
          {{ formatDate(promo.expiresAt) }}
        </div>
        <div class="cell">-</div>
        <div class="cell">{{ promo.claimsCount }}/{{ promo.maxClaims }}</div>
        <div class="cell">
          {{ promo.currency }}
          {{ promo.influencerDiscountAmount / 100 }},
          {{ promo.currency }}
          {{ promo.discountAmount / 100 }}
        </div>
        <div class="cell">
          {{ getInfluencerPromoClaimedDiscountCount(promo) }}
          ({{ promo.currency }}
          {{ getInfluencerPromoClaimedDiscountAmount(promo) / 100 }})
        </div>
        <div class="cell">
          {{ promo.appliedDiscountsCount }} ({{ promo.currency }}
          {{ promo.appliedDiscountsAmount / 100 }})
        </div>
      </div>
    </div>
    <router-link :to="{ name: 'createReferralCampaign' }">
      <button>Create referral campaign</button>
    </router-link>
    <router-link :to="{ name: 'createInfluencerCampaign' }">
      <button>Create influencer campaign</button>
    </router-link>
  </div>
</template>

<style scoped lang="less">
#data-table {
  grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto;
}
button {
  margin-top: 10px;
  border: 1px solid black;
  padding: 10px;
  cursor: pointer;
}
</style>

<script>
import api from "@/services/api";

export default {
  name: "campaigns",
  data() {
    return {
      referralCampaigns: [],
      influencerPromos: [],
      referralCampaignsOld: [],
      influencerPromosOld: [],
    };
  },
  async created() {
    const [referralCampaigns, influencerPromos] = await Promise.all([
      api.getReferralCampaigns(),
      api.getInfluencerPromos(),
    ]);
    Object.assign(this, {
      referralCampaigns: referralCampaigns.filter(campaign => this.getReferralCampaignStatus(campaign) === 'Active'),
      influencerPromos: influencerPromos.filter(campaign => this.getInfluencerPromoStatus(campaign) === 'Active'),
      referralCampaignsOld: referralCampaigns.filter(campaign => this.getReferralCampaignStatus(campaign) !== 'Active'),
      influencerPromosOld: influencerPromos.filter(campaign => this.getInfluencerPromoStatus(campaign) !== 'Active')
    });
  },
  methods: {
    getReferralCampaignTitle(campaign) {
      const country = Intl.DisplayNames
        ? new Intl.DisplayNames(["en"], { type: "region" }).of(campaign.country)
        : campaign.country;
      const endsAt = new Date(campaign.endsAt);
      const endsAtMonth = this.twoDigits(endsAt.getMonth() + 1);
      return `${country} Referrals ${endsAt.getFullYear()}-${endsAtMonth}`;
    },
    getReferralCampaignStatus(campaign) {
      if (new Date(campaign.endsAt) < new Date()) return "Expired";
      if (campaign.createdCodesCount >= campaign.maxCodes) return "Used";
      if (new Date(campaign.startsAt) > new Date()) return "Planned";
      return "Active";
    },
    getInfluencerPromoStatus(promo) {
      if (new Date(promo.expiresAt) < new Date()) return "Expired";
      if (promo.claimsCount >= promo.maxClaims) return "Used";
      return "Active";
    },
    getInfluencerPromoClaimedDiscountCount(promo) {
      const discountCountPerClaim = [
        promo.influencerDiscountAmount,
        promo.discountAmount,
      ].filter(Boolean).length;
      return promo.claimsCount * discountCountPerClaim;
    },
    getInfluencerPromoClaimedDiscountAmount(promo) {
      const discountAmountPerClaim =
        promo.influencerDiscountAmount + promo.discountAmount;
      return promo.claimsCount * discountAmountPerClaim;
    },
    formatDate: function (date) {
      const parsed = new Date(date);
      const hours = this.twoDigits(parsed.getHours());
      const minutes = this.twoDigits(parsed.getMinutes());
      return `${parsed.toLocaleDateString()} ${hours}:${minutes}`;
    },
    twoDigits(n) {
      return n.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    },
  },
};
</script>
